export default __webpack_public_path__ + "static/media/glasses6.881f7fbf.jpeg";